import { exposeClassnames as classnames } from '@stadionhq-v3/utilities';
import { Heading, Paragraph, PromoCardProps } from '@stadionhq-v3/base-ui';
import { ArrowRightLight } from '@components/icons';
import { PrimaryButton } from '@components/v3/atoms/button';
import styles from './promoCard.module.scss';

const PromoCard = ({
  title,
  summary,
  image,
  link,
  variant = 'standard',
  nativeProps,
  classNames,
}: PromoCardProps) => {
  const classes = classnames(
    [styles.tokens, styles.promoCard, variant === 'rich' && styles.rich],
    classNames
  );

  return (
    <article {...nativeProps} className={classes} data-component="PromoCard">
      <div className={classnames(styles.backgroundImage)}>{image}</div>

      <div className={styles.textPanel}>
        <div className={styles.text}>
          <div className={styles.titleContainer}>
            <Heading as="h6" classNames={[classnames(styles.title)]}>
              {title}
            </Heading>
          </div>

          <div className={styles.summaryContainer}>
            <Paragraph classNames={[classnames(styles.summary)]}>
              {summary}
            </Paragraph>
          </div>
        </div>

        <div className={styles.cta}>
          {link && variant === 'standard' && (
            <PrimaryButton
              classNames={[classnames(styles.button)]}
              text={link.title || ''}
              url={link.url || ''}
              iconAfter={<ArrowRightLight />}
            />
          )}
        </div>

        {link && (
          <a href={link.url} className={styles.floatingLink}>
            <span>{link.title}</span>
          </a>
        )}
      </div>
    </article>
  );
};

export default PromoCard;
